// Dashboard "Departments" panel — the same departments and modules as the
// sidebar (navConfig DEPARTMENTS, filtered by useVisibleNav), as cards of
// quick links. Hidden when the user can see no department.
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useVisibleNav } from "@/components/layout/navConfig";

export default function DepartmentsPanel() {
  const { user } = useAuth();
  const { visibleDepartments } = useVisibleNav(user);
  if (!visibleDepartments.length) return null;
  return (
    <div data-testid="dashboard-departments">
      <h3 className="text-lg font-semibold text-slate-800 mb-3" style={{ fontFamily: "Manrope" }}>Departments</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {visibleDepartments.map((d) => (
          <div key={d.key} className="bg-white border border-slate-200 rounded-lg p-4" data-testid={`dashboard-dept-${d.key}`}>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-8 h-8 rounded-md flex items-center justify-center text-blue-700 bg-blue-50">
                <d.icon className="w-4 h-4" />
              </span>
              <span className="font-semibold text-slate-800">{d.label}</span>
              <span className="ml-auto text-xs text-slate-400">{d.items.length}</span>
            </div>
            <ul className="space-y-0.5">
              {d.items.map((i) => (
                <li key={i.to}>
                  <Link
                    to={i.to}
                    className="flex items-center gap-2 rounded px-2 py-1 text-sm text-slate-600 hover:bg-slate-50 hover:text-blue-700"
                    data-testid={`dashboard-dept-link-${i.tid}`}
                  >
                    <i.icon className="w-3.5 h-3.5 shrink-0 text-slate-400" />
                    <span className="truncate">{i.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
